import {OrderModel} from "../Models/OrderModel";
import {OrderResponseModel} from "../Models/OrderResponseModel";
import {authMock} from "./authMock";
import {door1PdvsMock} from "./pdvs/door1Pdvsock";
import {eventMock} from "./eventMock";

export const orderResponseMock = (order: OrderModel): OrderResponseModel => {
  return {
      createdAt: new Date().toString(),
      reference: order.reference,
      priceHT: order.priceHT,
      priceTTC: order.priceTTC,
      discount: "null",
      discountRate: "null",
      discountName: "null",
      totalTva: order.totalTva,
      totalPriceHT: order.totalPriceHT,
      totalPriceTTC: order.totalPriceTTC,
      orderProducts: order.orderProducts,
      orderStates: [
          {
              status: "paid",
              createdAt: new Date().toString()
          }
      ],
      orderSlips: [],
      stadium: authMock.stadium,
      pdv: door1PdvsMock[0],
      event: eventMock
  }
}
